// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__297KR","toggle":"styles_toggle__3ysIL","preview":"styles_preview__3ZS2v"};